import axios from 'axios';
import { getApiBaseUrl } from '../auth';

const baseURL = getApiBaseUrl();

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';

api.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      const url: string = error?.config?.url ?? '';
      // `/auth/me` отвечает 401 для анонима по дизайну — это не истечение сессии.
      // Для остальных 401 сообщаем приложению, что сессия мертва: AppContent
      // сбросит локальное состояние, а RequireAuth/RequireAdmin сами уведут
      // пользователя с приватной страницы. Hard-reload на `/` не делаем — он
      // ломает прямые ссылки на публичные страницы.
      if (!url.includes('/auth/me')) {
        window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED_EVENT));
      }
    }
    return Promise.reject(error);
  }
);

export default api;
